"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINForm = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var uuid_1 = require("uuid");
var PINTextInput_1 = require("./PINTextInput");
var PINSelectInput_1 = require("./PINSelectInput/PINSelectInput");
var PINRadioInput_1 = require("./PINRadioInput");
var PINPlanInput_1 = require("./PINPlanInput");
var PINPhoneInput_1 = require("./PINPhoneInput");
var PINCheckboxInput_1 = require("./PINCheckboxInput");
var PINToggleInput_1 = require("./PINToggleInput");
var PINOpenChoicesInput_1 = require("./PINOpenChoicesInput");
var PINForm = /** @class */ (function (_super) {
    __extends(PINForm, _super);
    function PINForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = uuid_1.v4();
        _this.state = {};
        _this.key = 1;
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        _this.onInputChange = function (name, value, defaultValue, isValid) {
            _this.setState(function () {
                var _a;
                return (_a = {},
                    _a[name] = { isValid: isValid, value: value, defaultValue: defaultValue },
                    _a);
            });
            if (_this.props.onChange) {
                _this.props.onChange(name, value, isValid);
            }
            return value;
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
        _this.linkInput = function (component) {
            var onChange = component.props.onChange;
            /*
             * Set `onChangeForm` prop, along with `t`, `required` and `hiddenRequired`
             * if defined on PINForm
             */
            return React.cloneElement(component, {
                // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
                onChangeForm: function (name, newValue, defaultValue, error) {
                    _this.onInputChange(name, newValue, defaultValue, error === null);
                    if (onChange) {
                        onChange(name, newValue);
                    }
                },
                id: component.props.id || (component.props.name + "_" + _this.id),
                t: component.props.t || _this.props.t,
                required: component.props.required || _this.props.allRequired,
                hiddenRequired: component.props.hiddenRequired || _this.props.hiddenRequired
            });
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
        _this.updateSubmit = function (component) {
            // Form is valid if all the inputs are valid
            var formIsValid = true;
            var unchanged = true;
            for (var _i = 0, _a = Object.keys(_this.state); _i < _a.length; _i++) {
                var name_1 = _a[_i];
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                formIsValid = _this.state[name_1].isValid && formIsValid;
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                unchanged = unchanged && _this.state[name_1].defaultValue === _this.state[name_1].value;
            }
            return React.cloneElement(component, {
                disabled: !(formIsValid
                    && !(_this.props.requireChange && unchanged)
                    && !component.props.disabled),
            });
        };
        // @ts-expect-error ts-migrate(7024) FIXME: Function implicitly has return type 'any' because ... Remove this comment to see the full error message
        _this.prepareChildren = function (children) {
            var inputType = [
                PINTextInput_1.PINTextInput.className,
                PINSelectInput_1.PINSelectInput.className,
                PINRadioInput_1.PINRadioInput.className,
                PINPlanInput_1.PINPlanInput.className,
                PINPhoneInput_1.PINPhoneInput.className,
                PINCheckboxInput_1.PINCheckboxInput.className,
                PINToggleInput_1.PINToggleInput.className,
                PINOpenChoicesInput_1.PINOpenChoicesInput.className
            ];
            // For each children
            return React.Children.map(children, function (child) {
                var newChild = child;
                if (!child) {
                    return null;
                }
                // If it's an input
                if (child.type && inputType.indexOf(child.type.className) >= 0) {
                    // Check the name property
                    var name_2 = child.props.name;
                    if (name_2 === undefined || name_2 === null || name_2 === "") {
                        console.error(child.type.name + ": `name` prop is required for usage with PINForm.");
                    }
                    else {
                        // Link the input to the form (to be notified on change)
                        newChild = _this.linkInput(child);
                    }
                }
                // If it's a submit type elem
                if (newChild.props && newChild.props.type === "submit") {
                    // Link the submit input/button to the form (to control the disabled prop)
                    newChild = _this.updateSubmit(newChild);
                }
                // Prepare the chilren of this child and return the new element
                return newChild.props ? React.cloneElement(newChild, {
                    children: _this.prepareChildren(newChild.props.children)
                }) : newChild;
            });
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.onSubmit = function (event) {
            event.preventDefault();
            if (_this.props.onSubmit) {
                // Return an object with only the values of the inputs
                var form = {};
                for (var _i = 0, _a = Object.keys(_this.state); _i < _a.length; _i++) {
                    var name_3 = _a[_i];
                    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    form[name_3] = _this.state[name_3].value;
                }
                _this.props.onSubmit(form);
            }
        };
        return _this;
    }
    PINForm.prototype.componentWillMount = function () {
        this.prepareChildren(this.props.children);
    };
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'nextProps' implicitly has an 'any' type... Remove this comment to see the full error message
    PINForm.prototype.componentWillUpdate = function (nextProps) {
        if (!this.props.reset && nextProps.reset) {
            this.key++;
        }
    };
    PINForm.prototype.render = function () {
        var className = "pinform " + (this.props.className || "");
        var attr = __assign({}, this.props);
        delete attr.className;
        delete attr.onChange;
        delete attr.onSubmit;
        delete attr.hiddenRequired;
        delete attr.allRequired;
        delete attr.requireChange;
        delete attr.reset;
        delete attr.t;
        return (React.createElement("form", __assign({ key: this.key, className: className }, attr, { onSubmit: this.onSubmit }), this.prepareChildren(this.props.children)));
    };
    PINForm.propTypes = {
        onChange: PropTypes.func,
        t: PropTypes.func,
        hiddenRequired: PropTypes.bool,
        allRequired: PropTypes.bool,
        requireChange: PropTypes.bool,
        onSubmit: PropTypes.func
    };
    return PINForm;
}(React.Component));
exports.PINForm = PINForm;
//# sourceMappingURL=PINForm.js.map